import axios from "../../utils/axios";

async function fetchList(params) {
  return await axios.get("/dine-table", { params });
}

async function create(data) {
  return await axios.post("/dine-table", data);
}

async function addItemsToTable(data) {
  return await axios.patch("single/orders/dine-order/add-items", data);
}

async function removeItemFromTable(data) {
  return await axios.patch("single/orders/dine-order/remove-item", data);
}

export const tableService = {
  fetchList,
  create,
  addItemsToTable,
  removeItemFromTable,
};
